import { number, string } from 'prop-types'
import axios from 'axios'
import Cookies from 'js-cookie'
import React from 'react'
import queryString from 'query-string'
import Venue from './Venue'

class PreviousAndNextVenues extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      next: null,
      previous: null,
    }
  }
  componentDidMount() {
    const urlComponents = this.props.pathnameSearch.split('?')
    let query = {}
    if (urlComponents.length === 2) {
      query = queryString.parse(urlComponents[1])
    }
    axios.get('/api/previous-and-next', {
      params: {
        ...query,
        current_nid: this.props.currentNid,
      },
    }).then((res) => {
      this.setState({
        next: res.data.next,
        previous: res.data.previous,
      })
    })
  }
  handleClick = () => {
    Cookies.set('pathnameSearch', this.props.pathnameSearch)
  }
  render() {
    if (this.state.next === null && this.state.previous === null) {
      return null
    }
    return (
      <div className="previous-and-next-venues">
        <Venue
          onClick={this.handleClick}
          venue={this.state.previous}
          which="Previous"
        />
        <Venue
          onClick={this.handleClick}
          venue={this.state.next}
          which="Next"
        />
      </div>
    )
  }
}
PreviousAndNextVenues.propTypes = {
  currentNid: number.isRequired,
  pathnameSearch: string.isRequired,
}

export default PreviousAndNextVenues
